<template>
  <div :class="['SideNav-Container', `SideNav-Container-${$mq}`]" v-if="this.isUserLogged">
    <div class="desktop-wrapper" v-if="$mq == 'desktop'">
      <div class="side-bar-menu">
        <img src="../../../environments/vinovibes/theme/logo.png" class="logo" @click="goHome">
        <div class="side-bar-picture">
          <sidenav-profile-picture></sidenav-profile-picture>
          <div class="Profil">
            <div class="bonjour">Bonjour!</div>
            <div class="monProfil" @click="goto('userAccountPersonnalInformation')">Mon Profil</div>
          </div>
        </div>
        <sidenav-button-link
          :title="$t('home.formations')"
          ico="Masterclass"
          @click="goto('themeList')"
          :class="this.isActive('themeList')"
        />
        <sidenav-button-link
          v-if="remoteConfig.getBoolean('gamification_enabled')"
          :title="$t('home.progression')"
          ico="Progress"
          @click="goto('userProgression')"
          :class="this.isActive('userProgression')"
        />
        <sidenav-button-link
          :title="$t('home.tasting')"
          ico="Tastings"
          @click="goto('listTasting')"
          :class="this.isActive('listTasting')"
        />
        <sidenav-button-link
          :title="$t('menu.wines')"
          ico="panier"
          data-cy="sidenav.account"
          @click="goto('shop-list-bottles')"
          :class="this.isActive('shop-list-bottles')"
        />
        <vv-button class="journalButton" @click="goblog('https://vinovibes.fr/pages/blog')">Le journal d'Alvina</vv-button>
      </div>
    </div>
    <div v-else class="PhoneNav">
      <div :class="this.RouteActive('themeList')" @click="goto('themeList')">
        <img class="icon" :src="ico('Masterclass', 'themeList')">
        <div class="textObject">MasterClass</div>
      </div>
      <div :class="this.RouteActive('userProgression')" @click="goto('userProgression')">
        <img class="icon" :src="ico('Progressions', 'userProgression')">
        <div class="textObject">Progression</div>
      </div>
      <div :class="this.RouteActive('listTasting')" @click="goto('listTasting')">
        <img class="icon" :src="ico('Degustations', 'listTasting')">
        <div class="textObject">Dégustations</div>
      </div>
      <div :class="this.RouteActive('shop-list-bottles')" @click="goto('shop-list-bottles')">
        <img class="icon" :src="ico('Boutique', 'shop-list-bottles')">
        <div class="textObject">La boutique</div>
      </div>
      <div :class="this.RouteActive('userAccountPersonnalInformation')" @click="goto('userAccountPersonnalInformation')">
        <img class="icon" :src="ico('Profil', 'userAccountPersonnalInformation')">
        <div class="textObject">Mon profil</div>
      </div>
    </div>
  </div>
</template>

<script>
import { OPEN_NAVIGATION_DRAWER, CLOSE_NAVIGATION_DRAWER } from '@/helpers/eventBus'
import userMixin from '@/mixins/user'
import remoteConfigMixin from '@/mixins/remoteConfig'
import VvBoxItem from '@/components/common/VvBoxItem'
import VvButton from '@/components/common/VvButton'

import ProgressionIcon from '@/components/layout/svg/ProgressionIcon'
import PeopleIcon from '@/components/layout/svg/PeopleIcon'
import HeartIcon from '@/components/layout/svg/HeartIcon'
import CheersIcon from '@/components/layout/svg/CheersIcon'
import AbonnementIcon from '@/components/layout/svg/AbonnementIcon'
import LogoutIcon from '@/components/layout/svg/LogoutIcon'

import SidenavButtonLink from '@/components/layout/common/SidenavButtonLink'
import SidenavProfilePicture from '@/components/layout/common/SidenavProfilePicture'

export default {
  name: 'Sidenav',
  components: {
    ProgressionIcon,
    PeopleIcon,
    HeartIcon,
    CheersIcon,
    AbonnementIcon,
    LogoutIcon,
    VvBoxItem,
    SidenavButtonLink,
    SidenavProfilePicture,
    VvButton
  },
  mixins: [userMixin, remoteConfigMixin],
  data: () => ({
    isOpen: false,
    activeRoute: null
  }),
  computed: {
    isMobile() {
      return document.body.clientWidth < 767
    },
    welcomeMessage() {
      if (this.user && this.user.firstname) {
        return this.$t('userAccount.welcomeMessage', { firstname: this.user.firstname })
      } else {
        return this.$t('userAccount.anonymousWelcomeMessage')
      }
    },
    availableLocales() {
      const languages = this.remoteConfig.getString('languages')

      if (languages) {
        return languages.split('|')
      }

      return []
    },
    actualRoute() {
      return this.$route.name
    }
  },
  methods: {
    ico(title, route) {
      const tit = title + 'active'
      const src = this.actualRoute == route ? require(`@/assets/Sidenav/${tit}.svg`) : require(`@/assets/Sidenav/${title}.svg`)
      return src
    },
    goHome () {
      this.$router.push({name: 'home'})
    },
    isActive(routeName) {
      return this.actualRoute == routeName ? 'route-active' : ''
    },
    closeDrawer() {
      this.$eventBus.$emit(CLOSE_NAVIGATION_DRAWER)
    },
    goto(routeName) {
      this.activeRoute = routeName
      this.$router.push({ name: routeName })
      this.closeDrawer()
    },
    goblog(link) {
      window.open(link, "_blank");
    },
    logoutDrawer() {
      this.logout(() => {
        this.$router.push({ name: 'home' })
      })
      this.closeDrawer()
    },
    redirectToShop() {
      this.$router.push({ name: 'shop-list-bottles' })
    },
    RouteActive(route) {
      return this.actualRoute == route ? 'object active' : 'object'
    }
  },
  mounted() {
    this.$eventBus.$on(OPEN_NAVIGATION_DRAWER, () => {
      this.isOpen = true
    })

    this.$eventBus.$on(CLOSE_NAVIGATION_DRAWER, () => {
      this.isOpen = false
    })

    this.activeRoute = this.$route.name
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';
.textObject{
  margin-top: 5px;
  font-size: 11px;
}
.object{
  display: flex;
  flex-direction: column;
  align-items: center;
  // width: 100%;
  // height: 100%;
  // margin: 5px 0px 11px;
  padding-bottom: 13px;

  &:hover, &.active {
    padding: 30px 4px 15px 4px;
    border-radius: 36px 36px 0px 0px;
    background-color: $primary;
    color: white;
    font-size: 12px;
    transform: scale(1.2);
  }
}
.PhoneNav {
  display: flex;
  flex-direction: row;
  background-color: $primary-alt;
  justify-content: space-around;
  height: 100%;
  align-items: flex-end;
  // align-items: center;
  // margin-top: 50px;
  // align-items: flex-end;
}
.bonjour {
  color: $primary;
  margin-left: 10px;
  font-weight: 900;
}
.monProfil {
  font-size: 20px;
  margin-top: 10px;
  margin-left: 10px;
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    transform: scale(1.1);
  }
}
.profil {
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  margin-left: 20px;
}
.logo {
  width: 140px;
  height: auto;
  margin: 60px 0px;
  cursor: pointer;
  &:hover {
    transform: scale(1.05);
  }
}
.journalButton {
  width: 160px;
  margin: 70px 20px;
  padding: 14px 18px;
  border-radius: 40px;
  font-size: 17px;
  cursor: pointer;
    &:hover {
    transform: scale(1.01);
  }
}
.desktop-wrapper {
  background: $primary-alt;
  width: 250px;
  height: 100%;
  z-index: 1000;
  position: fixed;

}
.side-bar-menu {
  width: 250px;
  height: 80%;
  position: fixed;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 100;
  @media screen and (max-height: 619px) {
    overflow-y: scroll;
  }
}
.side-bar-picture {
  margin-bottom: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.SideNav-Container {
  display: inline-block;
  vertical-align: top;
  position: absolute;
  width: 180px;
  height: 100%;
  // padding-top: 80px;

  &.SideNav-Container-mobile, &.SideNav-Container-tablet {
    z-index: 1;
    position: fixed;
    // background: $primary-alt;
    left: 0;
    width: 100%;
    height: 70px;
    top: calc(100% - 70px);
  }

  &--small {
    display: block;
  }
}

.mobile-wrapper {
  display: block;
}

/* The side navigation menu */
.sidenav {
  height: 100%; /* 100% Full-height */
  width: 300px;
  position: fixed; /* Stay in place */
  z-index: 2; /* Stay on top */
  top: 0; /* Stay at the top */
  left: -300px;
  background-color: #fff;
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 10px; /* Place content 60px from the top */
  transition: 0.3s ease; /* 0.3 second transition effect to slide in the sidenav */

  &.open {
    transform: translate(100%, 0);
  }
}

.row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 300px;
}

.welcome-message {
  margin-left: 20px;
}

/* The navigation menu links */
.sidenav a {
  padding: 8px 15px 8px 32px;
  text-decoration: none;
  font-size: 30px;
  color: $font-color-light;
  display: block;
  transition: 0.3s;
}

/* When you mouse over the navigation links, change their color */
.sidenav a:hover {
  color: #f1f1f1;
}

.sidenav-tip {
  padding: 20px;
  max-width: 260px;
  height: 150px;
}

.sidenav-tip {
  margin: 10px auto;
}

/* Style page content - use this if you want to push the page content to the right when you open the side navigation */
#main {
  transition: margin-left 0.5s;
  padding: 20px;
}

/* On smaller screens, where height is less than 450px, change the style of the sidenav (less padding and a smaller font size) */
@media screen and (max-height: 450px) {
  .sidenav {
    padding-top: 15px;
  }
  .sidenav a {
    font-size: 18px;
  }
}

.SideNav-Desktop {
  display: inline-block;
  width: 360px;
  color: $dark;

  .SideNav-WelcomeText {
    padding: 0 45px;
    box-sizing: border-box;
    font-size: 15px;
    font-weight: 900;
    margin: 40px 0 20px;
  }
}
</style>
